import Routing from "./routes";

function App() {
  return (
      <Routing/>
  );
}

export default App;
